import { MockData } from '../data/MockData'

export class MockHelper {

  call(options, callback) {
    setTimeout(() => {
      return this._call(options, callback)
    }, 100)
  }

  hasMock(options) {
    const Url = require('url-parse')
    const url = new Url(options.endPoint)
    let data

    if (url.pathname.endsWith('/miscs/creativesearch')) {
      data = MockData.creatives
    }
    if (url.pathname.endsWith('/miscs/dayparting')) {
      data = MockData.dayparting
    }
    // if (url.pathname.endsWith('/miscs/creatives')) {
    //   data = MockData.creatives
    // }
    // if (url.pathname.endsWith('/miscs/contentreview')) {
    //   data = MockData.contentreview
    // }
    // if (url.pathname.endsWith('/miscs/campaigns/29378492')) {
    //   data = MockData.campaign
    // }
    // if (url.pathname.endsWith('/Prod/miscs/getPaymentUrl')) {
    //   data = MockData.paymentUrl
    // }
    // if (url.pathname.endsWith('/Prod/miscs/deviceactivity')) {
    //   data = MockData.devicesActivity2
    // }
    // if (url.pathname.endsWith('/Prod/miscs/dpactivity')) {
    //   data = MockData.dpActivity2
    // }
    // if (url.pathname.includes('/miscs/deviceactivity')) {
    //   console.log('MockData', MockData)
    //   // data = MockData.adminDevicesActivity
    //   data = MockData.deviceActivity
    // }
    // if (url.pathname.includes('/miscs/venue-fill-rate')) {
    //   data = MockData.venueFillRate
    // }
    if (url.pathname.includes('/miscs/screen-fill-history')) {
      data = MockData.screenPerformanceDashboard;
    }
    return data
  }

  _call(options, callback) {
    const data = this.hasMock(options)
    if (!data) return callback({ message: 'mock not found!' })
    return callback(null, data)
  }
}


// WEBPACK FOOTER //
// ./src/helpers/MockHelper.js